import { StyledLink } from "./styles";
import DirectionArrowIcon from "icons/DirectionArrowIcon";

const BackToView = ({
    to = "", 
    text = "Atrás",
    onClick,
}) => {
    return (
        <StyledLink to={to} onClick={onClick}>
            <DirectionArrowIcon/>
            <span>{text}</span>
        </StyledLink>
    );
}

export default BackToView;
